import { Link } from "react-router-dom";
import { Heart, Store, ArrowRight } from "lucide-react";
import { LegalLinks } from "./Legal";

export default function RegisterChoice() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <Link to="/" className="flex items-center gap-2.5 mb-10">
        <div className="w-9 h-9 rounded-xl bg-stone-900 flex items-center justify-center">
          <span className="text-champagne font-serif text-lg">A</span></div>
        <span className="font-serif text-lg">Notre Oui</span></Link>
      <h1 className="font-serif text-3xl lg:text-4xl text-stone-900 text-center">Comment souhaitez-vous utiliser la plateforme ?</h1>
      <div className="grid md:grid-cols-2 gap-5 mt-10 max-w-3xl w-full">
        <Link to="/register/couple" data-testid="choice-couple"
          className="card-lux p-8 group hover:shadow-xl transition-shadow">
          <div className="w-12 h-12 rounded-2xl bg-accent flex items-center justify-center mb-5">
            <Heart className="w-5 h-5 text-stone-800" /></div>
          <h2 className="font-serif text-2xl">Organiser mon mariage</h2>
          <p className="text-sm text-stone-500 mt-2">Planifiez votre mariage à deux : invités, budget, prestataires, RSVP, plan de table et jour J.</p>
          <div className="text-champagne text-sm mt-5 flex items-center gap-1 font-medium">Créer mon mariage <ArrowRight className="w-4 h-4" /></div>
        </Link>
        <Link to="/register/vendor" data-testid="choice-vendor"
          className="card-lux p-8 group hover:shadow-xl transition-shadow">
          <div className="w-12 h-12 rounded-2xl bg-stone-900 flex items-center justify-center mb-5">
            <Store className="w-5 h-5 text-champagne" /></div>
          <h2 className="font-serif text-2xl">Je suis prestataire</h2>
          <p className="text-sm text-stone-500 mt-2">Présentez vos services, recevez des demandes de devis et gérez vos réservations.</p>
          <div className="text-champagne text-sm mt-5 flex items-center gap-1 font-medium">Créer mon profil prestataire <ArrowRight className="w-4 h-4" /></div>
        </Link>
      </div>
      <p className="text-sm text-stone-500 mt-8">Déjà inscrit·e ? <Link to="/login" className="text-champagne font-medium">Se connecter</Link></p>
      <LegalLinks className="justify-center text-xs text-stone-400 mt-6" />
    </div>
  );
}
